// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AspectsTable_root__1AoP- {
  display: flex;
  flex-direction: column;
  padding: 32px 0;
}
.AspectsTable_root__1AoP-.AspectsTable_bare__g6whG {
  padding: 0;
}
.AspectsTable_root__1AoP- thead th {
  font-size: 10px;
  line-height: 24px;
  color: #111111;
  text-wrap: nowrap;
}
.AspectsTable_root__1AoP- tbody td {
  font-size: 10px;
  color: rgba(17, 17, 17, 0.6392156863);
  letter-spacing: 0.1px;
  text-transform: capitalize;
  vertical-align: middle;
}
.AspectsTable_root__1AoP- tbody tr.AspectsTable_active__TpMus td {
  background-color: #f2f2f2;
}
.AspectsTable_root__1AoP- .AspectsTable_actions__nmpgy {
  display: flex;
  gap: 8px;
}
.AspectsTable_root__1AoP- .AspectsTable_actions__nmpgy.AspectsTable_disabled__SU-kR {
  pointer-events: none;
}
.AspectsTable_root__1AoP- .AspectsTable_actions__nmpgy svg {
  cursor: pointer;
}
.AspectsTable_root__1AoP- .AspectsTable_actions__nmpgy svg.AspectsTable_disabled__SU-kR {
  cursor: default;
}
.AspectsTable_root__1AoP- .AspectsTable_header__6B8iJ {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.AspectsTable_root__1AoP- .AspectsTable_header__6B8iJ .AspectsTable_headerTop__VQUf2 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.AspectsTable_root__1AoP- .AspectsTable_header__6B8iJ h2 {
  text-transform: capitalize;
}
.AspectsTable_root__1AoP- .AspectsTable_header__6B8iJ .AspectsTable_notice__ZwFuN {
  width: 100%;
}
.AspectsTable_root__1AoP- .AspectsTable_header__6B8iJ .AspectsTable_notice__ZwFuN .alert {
  padding: 8px 64px;
}
.AspectsTable_root__1AoP- .AspectsTable_hideSelectionColumn__g1wQd tr > :first-child {
  display: none;
}
.AspectsTable_root__1AoP- .AspectsTable_updatedBy__3Sn0d {
  min-width: 100px;
}
.AspectsTable_root__1AoP- .AspectsTable_searchWrapper__aGRss {
  width: 500px;
}
.AspectsTable_root__1AoP- .AspectsTable_filterWrapper__ZyTJv {
  max-width: 500px;
}
.AspectsTable_root__1AoP- .AspectsTable_searchBar__1NwcR {
  width: 100%;
  display: flex;
  margin-bottom: 26px;
  justify-content: space-between;
}
.AspectsTable_root__1AoP- .AspectsTable_searchBar__1NwcR .AspectsTable_badge__1R2a0 {
  margin-left: 8px;
  line-height: 1;
  padding: 2px 4px;
}
.AspectsTable_root__1AoP- .AspectsTable_searchBar__1NwcR .AspectsTable_filtersSection__LhN2h {
  display: flex;
  align-items: center;
  gap: 8px;
}
.AspectsTable_root__1AoP- .AspectsTable_largeTextCell__Kplmu {
  max-width: 250px;
  word-wrap: break-word; /* Allows long words to break */
  overflow-wrap: break-word; /* Ensures compatibility */
  white-space: normal; /* Allows text to wrap */
}
.AspectsTable_root__1AoP- .AspectsTable_reuseJointButton__iP9aF {
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/AspectsTable/AspectsTable.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AACF;AAAE;EACE,UAAA;AAEJ;AAAE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAEJ;AAAE;EACE,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,aAAA;EACA,QAAA;AAEJ;AADI;EACE,oBAAA;AAGN;AADI;EACE,eAAA;AAGN;AAFM;EACE,eAAA;AAIR;AAAE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEJ;AADI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;AAGN;AADI;EACE,0BAAA;AAGN;AADI;EACE,WAAA;AAGN;AADM;EACE,iBAAA;AAGR;AAGI;EACE,aAAA;AADN;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,YAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AAQE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AANJ;AAQI;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AANN;AAQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANN;AAWE;EACE,gBAAA;EACA,qBAAA,EAAA,+BAAA;EACA,yBAAA,EAAA,0BAAA;EACA,mBAAA,EAAA,wBAAA;AATJ;AAYE;EACE,gBAAA;AAVJ","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 32px 0;\r\n  &.bare {\r\n    padding: 0;\r\n  }\r\n  thead th {\r\n    font-size: 10px;\r\n    line-height: 24px;\r\n    color: #111111;\r\n    text-wrap: nowrap;\r\n  }\r\n  tbody td {\r\n    font-size: 10px;\r\n    color: #111111a3;\r\n    letter-spacing: 0.1px;\r\n    text-transform: capitalize;\r\n    vertical-align: middle;\r\n  }\r\n  tbody tr.active td {\r\n    background-color: #f2f2f2;\r\n  }\r\n  .actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    &.disabled {\r\n      pointer-events: none;\r\n    }\r\n    svg {\r\n      cursor: pointer;\r\n      &.disabled {\r\n        cursor: default;\r\n      }\r\n    }\r\n  }\r\n  .header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    .headerTop {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: space-between;\r\n    }\r\n    h2 {\r\n      text-transform: capitalize;\r\n    }\r\n    .notice {\r\n      width: 100%;\r\n\r\n      :global(.alert) {\r\n        padding: 8px 64px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .hideSelectionColumn {\r\n    tr > :first-child {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  // Common fields\r\n  .updatedBy {\r\n    min-width: 100px;\r\n  }\r\n\r\n  .searchWrapper {\r\n    width: 500px;\r\n  }\r\n\r\n  .filterWrapper {\r\n    max-width: 500px;\r\n  }\r\n  .searchBar {\r\n    width: 100%;\r\n    display: flex;\r\n    margin-bottom: 26px;\r\n    justify-content: space-between;\r\n\r\n    .badge {\r\n      margin-left: 8px;\r\n      line-height: 1;\r\n      padding: 2px 4px;\r\n    }\r\n    .filtersSection {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n    }\r\n  }\r\n\r\n  // Large text cell\r\n  .largeTextCell {\r\n    max-width: 250px;\r\n    word-wrap: break-word; /* Allows long words to break */\r\n    overflow-wrap: break-word; /* Ensures compatibility */\r\n    white-space: normal; /* Allows text to wrap */\r\n  }\r\n\r\n  .reuseJointButton {\r\n    margin-left: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AspectsTable_root__1AoP-`,
	"bare": `AspectsTable_bare__g6whG`,
	"active": `AspectsTable_active__TpMus`,
	"actions": `AspectsTable_actions__nmpgy`,
	"disabled": `AspectsTable_disabled__SU-kR`,
	"header": `AspectsTable_header__6B8iJ`,
	"headerTop": `AspectsTable_headerTop__VQUf2`,
	"notice": `AspectsTable_notice__ZwFuN`,
	"hideSelectionColumn": `AspectsTable_hideSelectionColumn__g1wQd`,
	"updatedBy": `AspectsTable_updatedBy__3Sn0d`,
	"searchWrapper": `AspectsTable_searchWrapper__aGRss`,
	"filterWrapper": `AspectsTable_filterWrapper__ZyTJv`,
	"searchBar": `AspectsTable_searchBar__1NwcR`,
	"badge": `AspectsTable_badge__1R2a0`,
	"filtersSection": `AspectsTable_filtersSection__LhN2h`,
	"largeTextCell": `AspectsTable_largeTextCell__Kplmu`,
	"reuseJointButton": `AspectsTable_reuseJointButton__iP9aF`
};
export default ___CSS_LOADER_EXPORT___;
